import $ from "jquery";
import { EventBus } from "@/utils";
import sessionStorageObj from "@/Model/sessionStorageObj";
import storage from "@/Model/storage";
import axios from "axios";

// 在文件顶部添加调试模式判断变量
// 开发环境下process.env.NODE_ENV会被webpack设置为'development'
// 使用 npm run serve 或 npm run dev时，process.env.NODE_ENV会被设置为'development'
//      npm run build 启动项目时，process.env.NODE_ENV会被设置为 'production'
const IS_DEBUG_MODE = process.env.NODE_ENV === 'development';


// 获取url参数  #abc?a=1&b=2  返回 参数对象 {a:1,b:2}
const getSearchParams = searchURL => {
    if (!searchURL) return {};
    const paramsURL = searchURL.split("?")[1];
    if (!paramsURL) return {};
    const paramsArr = paramsURL.split("&");
    const outObj = {};
    for (let index = 0; index < paramsArr.length; index++) {
        const element = paramsArr[index].split("=");
        outObj[element[0]] = element[1];
    }
    return outObj;
};
const checkAuthorization = async ({ authorization }) => {
    const url = `${StarSoft.SysInfo.HttpMainUrl}/api/UnCheckPower/getLoginKey`;
    const data = await axios.post(url, {
        // authorization: authorization || ''
    }, {
        headers: {
            authorization: authorization
        }
    });
    console.log(data);
    // return data.Suc
    if (data && data.Suc) {
        return data.Data
    } else {
        return {}
    }
}
function fGetDomain(url) {
    /// <summary>获取引用页域名,用于获取菜单站的域名 add by chenk 2013.06.03</summary>
    /// <param name="url" type="String">页面链接，例如http://xxx.xx.com:ss/sdsds/.../asas.html</param>
    /// <returns type="String" />
    if (!url) {
        return "/";
    }
    var aUrl = url.split("//");
    if (aUrl.length < 2) {
        return fGetPageDomain();
    }
    var aDomain = aUrl[1].split("/");
    return aUrl[0] + "//" + aDomain[0] + "/";
}

function fGetPageDomain() {
    /// <summary>获取当前页的域名 add by chenk 2013.06.03</summary>
    var sUrl = document.URL;
    return fGetDomain(sUrl);
}

var pageDomain = fGetPageDomain();

var heartTo = 0; //心跳包延迟计数

/**
 * 开始执行心跳包
 */
function fHeartStart() {
    if (!StarSoft || !StarSoft.Data) {
        setTimeout(() => {
            fHeartStart();
        }, 200);
        return;
    }
    fHeartRun();
}

/**
 * 心跳包执行 add by chenk 2019.06.30
 */
function fHeartRun() {
    //商砼ERP不需要 add by chenk 2019.09.11
    // if (StarSoft.SysInfo.SysType == 1) {
    //     return;
    // }
    if (!StarSoft.isInitSys) {
        return;
    }
    var url = StarSoft.SysInfo.V8 + "MC6/api/User/Login/Heart";
    HeartGet("Get", url, "", function (rejson) {
        if (heartTo) {
            clearTimeout(heartTo);
        }
        if (rejson.Suc) {
            //写入会话有效期时间 add by chenk 2019.07.11
            localStorage.setItem(
                StarSoft.Keys.loginValid,
                new Date().format("yyyy-MM-Ddd HH:mm:ss")
            );
        }
        if (rejson.ErrCode != 5001) {
            heartTo = setTimeout(() => {
                fHeartRun();
            }, 1000 * 60 * 3); //最多不超过5分钟
        }
    });
}

function HeartGet(actionType, url, params, callback, noTimeout, isMultithread) {
    let ajaxOpt = {
        type: actionType,
        url: url,
        data: params,
        dataType: "json",
        cache: false,
        jsonp: "callback", //传递给请求处理程序或页面的，用以获得jsonp回调函数名的参数名(默认为:callback)
        //jsonpCallback: "success_jsonpCallback", //自定义的jsonp回调函数名称，默认为jQuery自动生成的随机函数名
        // timeout: (1000 * 20), //60秒
        beforeSend: function (xhr) {
            if (StarSoft.V8LoginKey) {
                xhr.setRequestHeader("loginkey", StarSoft.V8LoginKey);
            }
        },
        success: function (data) {
            callback && callback(data);
        }
    };
    if (StarSoft.V8LoginKey) {
        $.support.cors = true;
        ajaxOpt.crossDomain = true;
        //ajaxOpt.headers = { "loginkey": StarSoft.LoginKey };
    } else {
        if (actionType == "get") {
            ajaxOpt.dataType = "jsonp";
        } else {
            $.support.cors = true;
            ajaxOpt.crossDomain = true;
            //ajaxOpt.headers = { "loginkey": StarSoft.LoginKey };
        }
    }
    $.ajax(ajaxOpt);
}

/**
 * 初始化OPOA公用页面
 */
function fInitOPOAPage() {
    //商砼ERP不需要OPOA页面 add by chenk 2019.09.11
    if (StarSoft.SysInfo.SysType == 1) {
        return;
    }
    if (!StarSoft.vueHomePage) {
        setTimeout(function () {
            fInitOPOAPage();
        }, 50);
        return;
    }
    if (StarSoft.vueHomePage.$route.query.onepage) {
        oDebug.info("单页面打开不进行 OPOA页面加载");
        return;
    }
    oDebug.info("初始化OPOA公用页面");
    var isAddLoginkey = false;
    var iframeDomain = StarSoft.SysInfo.HttpMainUrl;
    var opoaURL = "/wuliu/UI/OPOA/LocalData.aspx";
    if (iframeDomain) {
        iframeDomain = fGetDomain(iframeDomain);
        var pageDomain = fGetPageDomain();
        if (iframeDomain != pageDomain) {
            isAddLoginkey = true;
            fSetCrossDomainUrl(iframeDomain);
        }
        opoaURL = iframeDomain + opoaURL;
    }
    if (isAddLoginkey) {
        opoaURL += "?loginkey=" + StarSoft.LoginKey;
    }
    if (StarSoft.isInitOPOA) {
        return;
    }
    StarSoft.isInitOPOA = true;
    if ($("#hideTemp").length == 0) {
        $("body").append('<div id="hideTemp" style="display:none"></div>');
    }
    setTimeout(() => {
        $("#hideTemp").append(
            '<iframe id="LocalData" name="LocalData" height="0" width="0" style="display: none" src="' +
            opoaURL +
            '"></iframe>'
        );
    }, 100);
}

/**
 * 跨域时第一次访问会失效  fcallback  带一个参数  true 需要加loginkey false 不需要加loginkey
 *
 */
function fSetCrossDomainUrl(domian, fcallback) {
    //商砼ERP不需要 add by chenk 2019.09.11
    if (StarSoft.SysInfo.SysType == 1) {
        fcallback && fcallback(false);
        return;
    }

    if (!StarSoft.LoginKey) {
        setTimeout(() => {
            fcallback && fcallback(false);
        }, 100);

        return;
    }
    var ids = domian.split("://");
    var id = domian;
    if (ids.length >= 2) {
        id = ids[1];
    }
    id = id.replace(/\./g, "_");
    id = id.replace(/\//g, "");
    id = id.replace(/\:/g, "__");
    if ($("#" + id).length != 0) {
        var iframe = $("#" + id)[0];
        try {
            if (
                getIframeControlValue(id, "isFinish") ||
                iframe.readyState === "complete" ||
                iframe.readyState == "loaded"
            ) {
                fcallback && fcallback(false);
            } else {
                setTimeout(() => {
                    fSetCrossDomainUrl(domian, fcallback);
                }, 100);
            }
        } catch (e) {
            setTimeout(() => {
                fcallback && fcallback(true);
            }, 100);
        }

        return;
    }
    var url = domian + "/crossdomian.aspx?loginkey=" + StarSoft.LoginKey;
    if ($("#hideTemp").length == 0) {
        $("body").append('<div id="hideTemp" style="display:none"></div>');
    }
    $("#hideTemp").append(
        '<iframe id="' +
        id +
        '" class="CrossDomain"  height="0" width="0" style="display: none" src="' +
        url +
        '"></iframe>'
    );

    var $iframe = $("#" + id)[0];
    try {
        //兼容IE７－８
        if ($iframe[0].attachEvent) {
            $iframe[0].attachEvent("onload", function () {
                fcallback && fcallback(false);
            });
        } else {
            $iframe[0].onload = function () {
                fcallback && fcallback(false);
            };
        }
    } catch (e) {
        setTimeout(() => {
            fcallback && fcallback(true);
        }, 100);
    }
}

//得取iframe中的某个变量值
function getIframeControlValue(iframeId, varId) {
    var ofrm = document.getElementById(iframeId).document;
    if (ofrm == undefined) {
        ofrm = document.getElementById(iframeId).contentWindow;
        var ff = ofrm[varId];
        return ff;
    } else {
        var ie = document.frames[iframeId].window[varId];
        return ie;
    }
}

function fGUID(s, len, radix) {
    /// <summary>获取GUID add by chenk 2016.07.11</summary>
    /// <param name="len" type="INT">长度，默认36</param>
    /// <param name="s" type="String">间隔，默认-</param
    /// <param name="radix" type="int">基数</param>

    var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(
        ""
    );
    var uuid = [],
        i;
    radix = radix || chars.length;

    if (len) {
        // Compact form
        for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
    } else {
        // rfc4122, version 4 form
        var r;
        s = s || "-";
        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = s;
        uuid[14] = "4";

        // Fill in random data.  At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | (Math.random() * 16);
                uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
            }
        }
    }
    return uuid.join("");
}

/**
 * 加载StarSoft.Data.js文件 add by chenk 2019.01.30
 */
function fLoadDatajs(callback) {
    //商砼ERP不需要 add by chenk 2019.09.11
    if (StarSoft.SysInfo.SysType == 1) {
        callback && callback();
        return;
    }
    if (StarSoft && StarSoft.Data) {
        callback && callback();
        return;
    }
    $.getScript(
        "./static/StarSoft/" +
        StarSoft.SysInfo.SSVersion.V1_1 +
        "/StarSoft.Data.js",
        function () {
            console.info("完成StarSoft.Data.js文件加载", StarSoft.Data);
            callback && callback();
            StarSoft.Data.User.fGetPowerCarTree(function (oData) {
                console.info("完成车辆权限树数据加载", oData);
            });
        }
    );
}

/**
 * 初始化默认全局参数 add by chenk
 */
function InitDefaultSysInfo(callback) {
    var pathname = location.pathname
    pathname = pathname.replace(/\//g, "");
    $.ajax({
        url: `GlobalParam${pathname ? "-" + pathname : ''}.json?v=` + Date.now(),
        type: "get", //GET
        //async: false,    //false 为同步，true 为异步
        dataType: "json", //返回的数据格式：
        success: function (data) {
            console.log("完成加载系统初始化参数");
            // console.log(data);
            StarSoft.SysInfo = data;
            if (location.hash.indexOf('#/ShowClientWeb') == -1 && location.hash.indexOf('#/LookEvidence') == -1) {
                $("#title").text(StarSoft.WebTitle || StarSoft.SysInfo.WebTitle);
            }
            callback && callback();
        },
        error: function (e) {
            console.error("加载系统初始化参数出错", e);
            StarSoft.SysInfo = {
                HttpMenuJson: "api/User/PowerData/GetMenuInfo",
                HomePage: "/emptyPage",
                IsHomePageScreen: 0,
                ExitLogin: "",
                SysTimeOut: 4,
                WebUrl: "",
                WebTitle: "智慧商砼企业综合管理系统",
                SysName: "",
                LogoPicUrl: "static/logo.png",
                LoginView: "../components/page/Login.vue",
                InitUrl: "api/User/PowerData/GetInitInfo",
                CheckLoginUrl: "api/User/Login/CheckLogin",
                LoginOutUrl: "api/User/Login/LoginOut",
                SSVersion: {
                    V1_1: "1.1"
                },
                SysType: 1
            };
            callback && callback();
        }
    });
}

/**
 * 获取首页路由，路由未初始化时返回空白页面路由 add by chenk 2019.01.09
 * @returns 路由
 */
function _GetIndexRouteRight() {
    var that = ApplicationMgr;
    var right;
    var homeRoute = "";
    var MenuData = StarSoft.Menudata;
    // if (StarSoft.SysInfo && StarSoft.SysInfo.HomePage) {
    //     console.log('object',StarSoft.SysInfo.HomePage,StarSoft.Menudata)
    //     homeRoute = StarSoft.SysInfo.HomePage;
    //     right = that.GetRightByRightCode(homeRoute);
    //     if (right) {
    //         return right;
    //     }
    // }
    for (var i = 0; i < MenuData.length; i++) {
        var FristItem = MenuData[i];
        //有页面的话直接返回当前菜单
        // console.log(StarSoft.Router);
        // console.log(this.$router.resolve("/" + that.GetMenuRouteCode(FristItem)));
        // console.log(1111111, FristItem.RightUrl, FristItem.RightUrl != 'BoardMgr/CarQueueKB');
        if (FristItem.RightUrl && FristItem.RightUrl != 'BoardMgr/CarQueueKB') {
            return FristItem;
        }
        var pageMenu = fGetChildMenu(MenuData, FristItem.RightId);
        if (pageMenu) {
            return pageMenu;
        }
    }
    return null;
}
/**
 * 查找拥有页面的子菜单 add by chenk 2019.09.20
 * @param       {array}         allMenu      所有菜单集合
 * @param       {int}           parentID        父菜单ID
 */
function fGetChildMenu(allMenu, parentID) {
    for (var i = 0; i < allMenu.length; i++) {
        var menu = allMenu[i];
        if (menu.ParentID != parentID) {
            continue;
        }
        if (menu.RightUrl && menu.RightUrl != 'BoardMgr/CarQueueKB') {
            return menu;
        }
        var pageMenu = fGetChildMenu(allMenu, menu.RightId);
        if (pageMenu) {
            return pageMenu;
        }
    }
    return null;
}

/**
 * 初始化路由
 * @param {object} initInfo 初始化信息  null 表示没有数据
 */
function fInitRoute(initInfo, callback) {
    if (!initInfo) {
        _InitRoute(null, callback);
        return;
    }
    StarSoft.isInitSys = true;
    // 生成菜单
    StarSoft.finshRouters = ApplicationMgr.InitLeftMenuData(false);
    var sendData = {
        UserName: StarSoft.InitInfo.LoginInfo.UserName,
        PWD: StarSoft.InitInfo.LoginInfo.UserPwd,
        CheckCode: ""
    };
    // LoginV8(sendData, initInfo, callback);
    _InitRoute(initInfo, callback);
    localStorage.setItem(StarSoft.Enum.isInitSys, "true");
}

/**
 * 初始化路由信息 为了方便修改 这里把代码单独迁移出来，其实是一个私有方法 add by chenk 2018.01.03
 *  @param {function} callback 回调方法 带一个参数initInfo,如果为null则表示已经初始化过
 * @param {object}    initInfo 系统参数 包含菜单信息 主要用于构造路由
 */
function _InitRoute(initInfo, callback) {
    var that = ApplicationMgr;
    var Datax = initInfo;
    var routesData = StarSoft.Router.options.routes;
    if (!Datax || !StarSoft.Menudata || StarSoft.Menudata.length <= 0) {
        //无菜单数据。
        routesData[0].redirect = "/NoPower";
        callback && callback(initInfo);
        return;
    }

    var menus = fProChildRoute(0, 0);

    //fLoadDatajs(fCreateRoute);
    fCreateRoute();

    function fCreateRoute() {
        var defaultMenus = routesData[1].children.slice(
            0,
            StarSoft.MenuBaseLen
        );
        routesData[1].children = defaultMenus.concat(menus);
        routesData[0].redirect = that.GetIndexRoute(true);
        StarSoft.Router.addRoutes(routesData);
        if (callback) {
            callback && callback(initInfo);
        }
        //商砼ERP不需要 add by chenk 2019.09.11
        // if (StarSoft.SysInfo.SysType == 1) {
        //     return;
        // }
        if (!initInfo) return;
        if (location.hash.indexOf('#/ShowClientWeb') === -1 && location.hash.indexOf('#/LookEvidence') === -1 && location.hash.indexOf('#/repair') === -1 && location.hash.indexOf('#/carInfo') === -1 && location.hash.indexOf('noTop') === -1 && location.hash.indexOf('onepage') === -1 && StarSoft.SysInfo.IsShowWarn) {
            StarSoft.Data.User.fGetPowerCarTree(function (oData) {
                console.info("完成车辆权限树数据加载", oData);
                EventBus.trigger("CarTreeFinish");
                StarSoft.CarTreeFinish = true;
            });
        }
        // StarSoft.Data.SJG.fGetPowerSJG(function (oData) {
        //     console.log("完成砂浆罐数据加载", oData);
        //     // loadJs.SJG(() => {
        //     //     StarSoft.SJGData = new StarSoft.SJGClass({
        //     //         carList: oData.SJG.map(item => item.SOID)
        //     //     });
        //     // });
        // });
        // StarSoft.Data.SJG.fGetFacAndBuildsetTree(function (oData) {
        //     console.log("完成砂浆罐数据加载", oData);
        // });
    }

    /**
     * 获取首页默认路由
     */
    function GetDefaultRoute(MenuData) { }

    /**
     * 查找子菜单拥有页面的菜单
     * @param {object} menuItem 菜单节点
     * @returns 返回子菜单节点  null表示没有
     */
    function fGetChildMenu(menuItem) { }
    /**
     * 创建路由
     */
    function fProChildRoute(parentMenuID, parentIndex, sendTopParentID) {
        var routeZindex = parentIndex + 1;
        var routes = [];
        for (var i = 0; i < StarSoft.Menudata.length; i++) {
            if (StarSoft.Menudata[i].ParentID == 0) {
                StarSoft.Menudata[i].TopParentID = StarSoft.Menudata[i].RightId;
            } else {
                StarSoft.Menudata[i].TopParentID = sendTopParentID;
            }
            var item = StarSoft.Menudata[i];
            if (item.ParentID != parentMenuID) {
                continue;
            }
            // if(item.RightId==1220){
            //         debugger;
            // }

            var obj = fMenuToRoute(item, routeZindex);
            routes.push(obj);
            var childroutes = fProChildRoute(
                item.RightId,
                routeZindex,
                item.TopParentID
            );
            if (item.RightName == "发车计划") {
                console.info("发车计划", i, obj);
            }

            //#region 上级路由没有页面则自动显示子路由页面  不需要了 modify by chenk 2019.05.31
            if (!obj.meta.HasPage && StarSoft.SysInfo.SysType == 1) {
                var hasPageChild = childroutes.find(p => {
                    return p.meta.HasPage;
                });
                if (hasPageChild) {
                    obj.meta = $.extend({}, hasPageChild.meta);
                    obj.meta.RightId = item.RightId;
                    obj.meta.ParentID = item.ParentID;
                    obj.meta.zIndex = routeZindex;

                    // obj.meta.MenuType = item.MenuType;
                    // obj.meta.title = item.RightName;
                    // obj.meta.RightId = hasPageChild.meta.RightId;
                }
            }
            //#endregion 上级路由没有页面则自动显示子路由页面

            if (childroutes.length != 0) {
                routes = routes.concat(childroutes);
            }
        }
        return routes;
    }
    /**
     * 菜单转化为路由对象
     */
    function fMenuToRoute(menu, zindex) {

        // 在调试模式下设置固定的HttpMainUrl
        if (IS_DEBUG_MODE) {
            StarSoft.SysInfo.HttpMainUrl = "http://192.168.40.103:9020/web/"
            //StarSoft.SysInfo.HttpMainUrl = "http://192.168.40.103:9023/web/"
            //StarSoft.SysInfo.HttpMainUrl = "http://192.168.40.103:9015/web/"
            //StarSoft.SysInfo.HttpMainUrl = "https://stzx.xingruan.net/Web/"
            //StarSoft.SysInfo.HttpMainUrl = "https://stxcx.gpskk.com/Web/"
        }
        var item = menu;
        var HasPage = !!item.RightUrl;
        var obj = {
            path: "/" + ApplicationMgr.GetMenuRouteCode(item),
            component: resolve =>
                require(["../components/page/emptyPage.vue"], resolve),
            //component:_import(item.RightUrl), //addby xzz 有报错 部分页面没找到
            meta: {
                title: item.RightName,
                // src: item.IsIframe
                //     ? item.UrlPrefix + item.RightUrl
                //     : StarSoft.SysInfo.HttpMainUrl + item.RightUrl, 
                src: item.UrlPrefix + item.RightUrl,
                RightUrl: item.RightUrl,
                RightId: item.RightId,
                RightCode: item.RightCode,
                ParentID: item.ParentID,
                TopParentID: item.TopParentID,
                HasPage: HasPage,
                keepAlive: item.KeepAlive,
                isIframe: item.IsIframe,
                IsNotifyClient: item.IsNotifyClient,
                zIndex: zindex,
                MenuType: item.MenuType,
                // url: item.IsIframe
                //     ? item.UrlPrefix + item.TargetUrl
                //     : StarSoft.SysInfo.HttpMainUrl + item.TargetUrl,
                url: item.UrlPrefix + item.TargetUrl,
                // 在调试模式下使用固定URL，否则使用原来的逻辑
                url: IS_DEBUG_MODE ? 
                     "http://192.168.40.103:9020/" + item.UrlPrefix + item.TargetUrl : 
                     item.UrlPrefix + item.TargetUrl,
                // url: 'http://192.168.40.103:9020/' + item.UrlPrefix + item.TargetUrl,
                // url: 'http://192.168.40.103:9023/' + item.UrlPrefix + item.TargetUrl,
                //url: 'http://192.168.40.103:9015/' + item.UrlPrefix + item.TargetUrl,
                // url: 'https://stzx.xingruan.net/' + item.UrlPrefix + item.TargetUrl,
                // url: 'https://stxcx.gpskk.com/' + item.UrlPrefix + item.TargetUrl,
                TargetUrl: item.TargetUrl,
                UrlPrefix: item.UrlPrefix,
                UrlPrefix: IS_DEBUG_MODE ? 'http://192.168.40.103:9020/' + item.UrlPrefix :
                           item.UrlPrefix,
                // UrlPrefix: 'http://192.168.40.103:9023/' + item.UrlPrefix,
                //UrlPrefix: 'http://192.168.40.103:9015/' + item.UrlPrefix,
                // UrlPrefix: 'https://stzx.xingruan.net/' + item.UrlPrefix,
                // UrlPrefix: 'https://stxcx.gpskk.com/' + item.UrlPrefix,
                tabId: ApplicationMgr.GetMenuTabID(item),
                Query: item.Query
            },
            name: ApplicationMgr.GetMenuTabID(item)
        };
        if (item.IsIframe) {
            obj.meta.src = item.RightUrl;
        }
        if (HasPage) {
            if (item.IsIframe) {
                //改为在iframe里进行解析  mofify by chenk 2019.01.10
                // if (obj.meta.src.indexOf('?') === -1) {
                //         obj.meta.src += "?";
                // }
                // obj.meta.src += `&LoginKey=${StarSoft.LoginKey}`;
            } else {
                obj.component = getViews(item);
            }
        }
        return obj;
    }

    function getViews(menu) {
        var path = menu.RightUrl;
        //return () => import('@/components/page/' + path + '.vue');
        return () =>
            import(/* webpackChunkName: "[request]" */ `@/components/page/${path}`);
    }
}

/**
 * 加载系统信息
 */
function GetInitInfo(callback) {
    // var isHttps = window.location.href.indexOf("https") === 0;
    // if (isHttps) {
    //     StarSoft.SysInfo.HttpMainUrl.replace("http", "https");
    // }
    if (!StarSoft.isLogin) {
        // url加载
        var reLogin = fLoginByKey(callback);
        if (reLogin) {
            return;
        }
    }
    var loacalInitInfo = storage.get(StarSoft.Keys.initInfo);
    if (
        StarSoft.LoginKey &&
        loacalInitInfo && loacalInitInfo.LoginInfo &&
        loacalInitInfo.LoginInfo.LoginKey == StarSoft.LoginKey
    ) {
        var UserInfo = localStorage.getItem('UserInfo') ? JSON.parse(localStorage.getItem('UserInfo')) : {}
        StarSoft.UserName = UserInfo.UserName
        StarSoft.PersonName = UserInfo.PersonName
        StarSoft.CompanyName = UserInfo.CompanyName
        StarSoft.mobile = UserInfo.mobile
        StarSoft.UserID = UserInfo.UserID
        StarSoft.GPSUserID = UserInfo.GPSUserID
        fInitInitInfo(loacalInitInfo, callback);
        return;
    }
    if (!StarSoft.LoginKey) {
        GetInitInfoLoginOut(callback);
        return
    }
    var ajaxOpt = {
        url: StarSoft.SysInfo.HttpMainUrl + StarSoft.SysInfo.InitUrl,
        // url: "http://192.168.40.103:9015/web/" + StarSoft.SysInfo.InitUrl,
        type: "get", //GET
        beforeSend: function (xhr) {
            if (StarSoft.LoginKey) {
                xhr.setRequestHeader("loginkey", StarSoft.LoginKey);
            }
            xhr.setRequestHeader("Content-Type", 'application/json; charset=utf-8');
        },
        //async: false,    //或false,是否异步
        dataType: "json", //返回的数据格式：
        success: function (data) {
            if (!data.Suc) {
                console.log("系统初始化", data.Info);
                // alert(data.Info);
                if (data.ErrCode == 5001) {
                    //var lastPage = localStorage.getItem(StarSoft.Keys.lastPage);
                    var isLogin = localStorage.getItem(StarSoft.Keys.isLogin);
                    var loginValid = localStorage.getItem(
                        StarSoft.Keys.loginValid
                    );
                    if (loginValid) {
                        loginValid = Date.StrToDate(loginValid);
                        if (new Date().dateDiff(loginValid, "m") >= 120) {
                            isLogin = false;
                        } else {
                            isLogin = true;
                        }
                    }
                    if (isLogin) {
                        //取消登录返回上次页面 modify by chenk 2019.07.05  || (lastPage && StarSoft.noAlertPage.indexOf(lastPage) == -1)
                        if (!isLoginPage) {
                            $message("会话超时,请重新登陆", "error");
                        } else {
                            isLoginPage = false;
                        }

                        localStorage.setItem(StarSoft.Keys.isLogin, "");
                        localStorage.setItem(StarSoft.Keys.loginValid, "");
                    }
                    if (location.hash && location.hash != "#/login") {
                        localStorage.setItem("overtime", "true");
                    }
                    if (isLogin) {
                        ApplicationMgr.LoginOut(function () {
                            GetInitInfoLoginOut(callback);
                        }, true);
                    } else {
                        GetInitInfoLoginOut(callback);
                    }
                    return;
                } else {
                    $message("异常错误：" + data.Info, "error");
                    if (StarSoft.isInitSys) {
                        location.hash = "/login";
                        return;
                    }
                }
                GetInitInfoLoginOut(callback);
                return;
            }
            storage.set(StarSoft.Keys.initInfo, data.Data);
            fInitInitInfo(data.Data, callback);
            //todo  改为按需下载 modify by chenk 2019.05.15 fInitOPOAPage();
            return;
        },
        error: function (e) {
            fInitRoute(null, callback);
        }
    };
    var iframeDomain = fGetDomain(ajaxOpt.url);
    if (pageDomain != iframeDomain) {
        $.support.cors = true;
        ajaxOpt.crossDomain = true;
    }

    $.ajax(ajaxOpt);
}

/**
 * 通过 url里的GUID进行登录，返回0表示没起作用1成功-1失败 跳转到无权限页面
 */
function fLoginByKey(callback) {
    // return
    //http://v8.xingruan.net/?U_SID=&rid=
    //U_SID表示传递进来的GUID，用于直接登录  测试值  a4a9fa3a-a13a-4127-a0e7-2494d4dfabcb
    //rig表示菜单Rightid
    let arr = window.location.hash.split("?")[1]; //.split("&");
    let U_SID = gfRequest("U_SID", arr);
    let rid = gfRequest("rid", arr);
    if (!U_SID) {
        return 0;
    }
    StarSoft.ShowLeftRightID = rid;
    StarSoft.U_SID = U_SID;
    // let loacalInitInfo = null;
    // let catch_U_SID = localStorage.getItem("U_SID");
    let url = `${StarSoft.SysInfo.HttpMainUrl
        }api/User/Login/CheckLoginByKey?Key=${U_SID}`;
    // StarSoft.Data.fAjax("Post", url, "", function (rejson) {
    //     if (rejson.Suc) {
    //         localStorage.setItem(StarSoft.Enum.isInitSys, "");
    //         StarSoft.LoginKey = rejson.Data.LoginKey;
    //         //debugger;
    //         //验证缓存里是否已经存在相关数据
    //         // if (catch_U_SID == StarSoft.U_SID) {
    //         //     loacalInitInfo = storage.get(StarSoft.Keys.initInfo);
    //         //     if (
    //         //         StarSoft.LoginKey &&
    //         //         loacalInitInfo &&
    //         //         loacalInitInfo.LoginInfo.LoginKey == StarSoft.LoginKey
    //         //     ) {
    //         //         fInitInitInfo(loacalInitInfo, fOpenPage);
    //         //         return;
    //         //     }
    //         // }
    //         fLoginSucCallback(rejson.Data.LoginKey, fOpenPage);
    //     } else {
    //         callback && callback();
    //         // 头部侧边隐藏
    //         StarSoft.showLeftNav = false;
    //         StarSoft.topInfoNav = false;
    //         location.hash = "#/NoPower";
    //     }
    // });
    $.ajax({
        headers: {
            "loginKey": U_SID//此处放置请求到的用户token
        },
        url: url,
        type: "Post",
        contentType: "application/json",
        dataType: 'json',
        cache: false,
        async: true,
        success: function (res) {
            if (res.Suc) {
                localStorage.setItem(StarSoft.Enum.isInitSys, "");
                StarSoft.LoginKey = res.Data.LoginKey;
                fLoginSucCallback(res.Data.LoginKey, fOpenPage);
            } else {
                callback && callback();
                // 头部侧边隐藏
                StarSoft.showLeftNav = false;
                StarSoft.topInfoNav = false;
                location.hash = "#/NoPower";
            }
        },
        error: function () {
            alert("请求失败！");
        }
    });
    function fOpenPage(data) {
        callback && callback();
        // 左侧菜单初始化
        StarSoft.MenuFilter = ApplicationMgr.InitLeftMenuData(true);
        if (StarSoft.MenuFilter.length == 0) {
            StarSoft.ShowLeftRightID = "/NoPower";
            location.hash = "#" + StarSoft.ShowLeftRightID;
            return;
        }
        //todo 按照rid进行路由跳转
        location.hash = "#" + StarSoft.ShowLeftRightID;
    }
    return 1;
}

function fLoginSucCallback(loginKey, callback) {
    console.warn("loginKey", loginKey);
    fClearLoginCatch();
    if (location.hash.indexOf('#/ShowClientWeb') == -1 && location.hash.indexOf('#/LookEvidence') == -1) {
        $("#title").text(StarSoft.WebTitle || StarSoft.SysInfo.WebTitle);
    }
    localStorage.setItem("loginKey", loginKey);
    localStorage.setItem("V8LoginKey", loginKey);
    StarSoft.V8LoginKey = loginKey;
    if (StarSoft.U_SID) {
        localStorage.setItem("U_SID", StarSoft.U_SID);
    }
    localStorage.setItem(StarSoft.Enum.isInitSys, "");
    StarSoft.LoginKey = loginKey;
    StarSoft.isLogin = true;

    var domain = ApplicationMgr.fGetDomain(StarSoft.SysInfo.HttpMainUrl);
    var pageDomian = ApplicationMgr.fGetDomain(document.URL);
    if (domain != pageDomian) {
        ApplicationMgr.fSetCrossDomainUrl(domain, function (isAddLoginkey) {
            ApplicationMgr.InitSys(callback);
        });
        return;
    } else {
        ApplicationMgr.InitSys(callback);
    }
}

/**
 * 初始化初始信息 add by chenk 2019.08.07
 */
function fInitInitInfo(data, callback) {
    StarSoft.ComID = data.LoginInfo.CompanyID;
    var InitInfo = (StarSoft.InitInfo = data);
    StarSoft.InitInfo.LoginInfo.UserName = StarSoft.UserName
    if (InitInfo.LoginInfo) {
        var loginInfo = InitInfo.LoginInfo;
        StarSoft.LoginKey = loginInfo.LoginKey;
        StarSoft.V8LoginKey = loginInfo.LoginKey;
        if (loginInfo.Sys) {
            fRemoveEnptyKey(loginInfo.Sys);
            $.extend(StarSoft.SysInfo, loginInfo.Sys);
        }
    }

    if (InitInfo.FristMenuData && InitInfo.FristMenuData.length != 0) {
        StarSoft.Menudata = [];
        StarSoft.Menudata = StarSoft.Menudata.concat(InitInfo.FristMenuData);
    }
    if (InitInfo.SecondMenuData && InitInfo.SecondMenuData.length != 0) {
        StarSoft.Menudata = StarSoft.Menudata.concat(InitInfo.SecondMenuData);
        if (InitInfo.ThirdMenuData && InitInfo.ThirdMenuData.length != 0) {
            StarSoft.Menudata = StarSoft.Menudata.concat(
                InitInfo.ThirdMenuData
            );
            if (InitInfo.FourMenuData && InitInfo.FourMenuData.length != 0) {
                StarSoft.Menudata = StarSoft.Menudata.concat(
                    InitInfo.FourMenuData
                );
            }
        }
    }
    // StarSoft.Menudata.push({
    //     "UrlPrefix": "http://192.168.40.103:9020/Web/",
    //     "ImgMark": "",
    //     "IsList": 1,
    //     "LevelIndex": "2",
    //     "ParentID": 94050000,
    //     "RightCode": "GPF_STZX_QZJZX_IDCONFIG",
    //     "RightId": 94050200,
    //     "RightName": "前置机ID分配",
    //     "RightType": 1,
    //     "RightUrl": "FrontService/FrontServiceConfig",
    //     "SortOrder": 26,
    //     "TargetUrl": "api/ConcreteCloudPlat/FrontService/FrontServiceConfig",
    //     "KeepAlive": false,
    //     "IsIframe": false,
    //     "IsHide": true,
    //     "IsNotifyClient": 100,
    //     "openWin": false
    // })
    // StarSoft.Menudata.push({
    //     "UrlPrefix": "http://192.168.40.103:9020/Web/",
    //     "ImgMark": "",
    //     "IsList": 1,
    //     "LevelIndex": "2",
    //     "ParentID": 94050000,
    //     "RightCode": "GPF_STZX_QZJZX_SERVICMGR",
    //     "RightId": 94050300,
    //     "RightName": "前置机服务管理",
    //     "RightType": 1,
    //     "RightUrl": "FrontService/FrontServiceMgr",
    //     "SortOrder": 27,
    //     "TargetUrl": "api/ConcreteCloudPlat/FrontService/FrontServiceMgr",
    //     "KeepAlive": false,
    //     "IsIframe": false,
    //     "IsHide": true,
    //     "IsNotifyClient": 100,
    //     "openWin": false
    // })
    fInitRoute(InitInfo, callback);
}

/**
 * 加载系统信息 超时退出执行方法
 */
function GetInitInfoLoginOut(callback) {
    var domain = ApplicationMgr.fGetDomain(StarSoft.SysInfo.HttpMainUrl);
    var pageDomian = ApplicationMgr.fGetDomain(document.URL);
    if (domain != pageDomian) {
        ApplicationMgr.fSetCrossDomainUrl(domain, function (isAddLoginkey) {
            fInitRoute(null, callback);
        });
        return;
    }
    var domain = fGetDomain(StarSoft.SysInfo.HttpMainUrl);
    var pageDomian = fGetDomain(document.URL);
    if (domain != pageDomian) {
        fSetCrossDomainUrl(domain, function (isAddLoginkey) {
            fInitRoute(null, callback);
        });
        return;
    }
    fInitRoute(null, callback);
}

/**
 * 会员登录 add by chenk 2019.08.07
 */
function fLogin(vuePage, form, callback) {
    // StarSoft.SysInfo.HttpMainUrl = 'http://192.168.40.103:9020/web/'
    var url = StarSoft.SysInfo.HttpMainUrl + StarSoft.SysInfo.CheckLoginUrl;
    var ajaxOpt = {
        headers: {
            "Content-Type": 'application/json; charset=utf-8'//此处放置请求到的用户token
        },
        url,
        type: "post",
        data: JSON.stringify(form),
        beforeSend: function (xhr) {
            // xhr.setRequestHeader("Content-Type", 'application/json; charset=utf-8');
        },
        //async: false,    //或false,是否异步
        dataType: "json", //返回的数据格式：
        success: function (data) {
            if (!data.Suc) {
                vuePage.GUID = data.GUID;
                vuePage.$message.error(data.Info);
                callback && callback(data);
                if (data.Data.IsCheckCode) {
                    vuePage.showPic = true;
                    vuePage.handlePic();
                    // vuePage.checkUrl = data.Sys.HttpMainUrl + data.CheckUrl;
                    // vuePage.imgSrc = data.Sys.HttpMainUrl + data.CheckUrl;
                    vuePage.refesh();
                }
                return;
            }
            localStorage.setItem('UserInfo', JSON.stringify(data.Data))
            StarSoft.UserName = data.Data.UserName
            StarSoft.PersonName = data.Data.PersonName
            StarSoft.CompanyName = data.Data.CompanyName
            StarSoft.mobile = data.Data.mobile
            StarSoft.UserID = data.Data.UserID
            StarSoft.GPSUserID = data.Data.GPSUserID
            // $message("登陆成功!");
            $message(data.Info);
            fLoginSucCallback(data.Data.LoginKey, callback);
            return;
        },
        error: function (e) {
        }
    };

    $.ajax(ajaxOpt);
    // StarSoft.Data.fAjax("post", url, form, function (reJson) {
    //     var data = reJson.Data;
    //     if (!reJson.Suc) {
    //         vuePage.GUID = reJson.GUID;
    //         vuePage.$message.error(reJson.Info);
    //         callback && callback(reJson);
    //         if (reJson.Data.IsCheckCode) {
    //             vuePage.showPic = true;
    //             vuePage.handlePic();
    //             // vuePage.checkUrl = data.Sys.HttpMainUrl + data.CheckUrl;
    //             // vuePage.imgSrc = data.Sys.HttpMainUrl + data.CheckUrl;
    //             vuePage.refesh();
    //         }
    //         return;
    //     }
    //     $message("登陆成功!");
    //     // LoginV8(sendData);
    //     fLoginSucCallback(data.LoginKey, callback);
    //     // fClearLoginCatch();
    //     // $("#title").text(StarSoft.SysInfo.WebTitle);
    //     // localStorage.setItem("loginKey", data.LoginKey);
    //     // localStorage.setItem(StarSoft.Enum.isInitSys, "");
    //     // StarSoft.LoginKey = data.LoginKey;

    //     // var domain = ApplicationMgr.fGetDomain(
    //     //         StarSoft.SysInfo.HttpMainUrl
    //     // );
    //     // var pageDomian = ApplicationMgr.fGetDomain(document.URL);
    //     // if (domain != pageDomian) {
    //     //         ApplicationMgr.fSetCrossDomainUrl(domain, function (
    //     //                 isAddLoginkey
    //     //         ) {
    //     //                 ApplicationMgr.InitSys(callback);
    //     //         });
    //     //         return;
    //     // } else {
    //     //         ApplicationMgr.InitSys(callback);
    //     // }

    //     return;
    // });
}

function LoginV8(sendData, initInfo, callback) {
    var url = StarSoft.SysInfo.V8 + "MC6/" + StarSoft.SysInfo.CheckLoginUrl;
    // var sendParams = new URLSearchParams();
    // Object.keys(sendData).forEach(key => {
    //     sendParams.append(key, sendData[key]);
    // });
    // fetch(url, {
    //     method: "POST",
    //     headers: {
    //         "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    //     },
    //     body: sendParams
    // })
    //     .then(res => {
    //         return res.json();
    //     })
    //     .then(reJson => {
    //         if (reJson.Suc) {
    //             localStorage.setItem("V8LoginKey", reJson.Data.LoginKey);
    //             StarSoft.V8LoginKey = reJson.Data.LoginKey;
    //         } else {
    //             localStorage.removeItem("V8LoginKey");
    //         }
    //         fHeartStart();
    //         _InitRoute(initInfo, callback);
    //     });
    StarSoft.Data.fAjax("post", url, sendData, function (reJson) {
        if (reJson.Suc) {
            localStorage.setItem("V8LoginKey", reJson.Data.LoginKey);
            StarSoft.V8LoginKey = reJson.Data.LoginKey;
        } else {
            localStorage.removeItem("V8LoginKey");
        }
        fHeartStart();
        _InitRoute(initInfo, callback);
    });
}

var ApplicationMgr = {
    ClearSessionData: function () {
        storage.remove("PersonName");
        storage.remove("LoginInfo");
        sessionStorageObj.remove("param");
        sessionStorageObj.remove("MenuData");
    },
    GetLogoPicUrl: function () {
        if (this.GetGlobalParam() == null) {
            //
            this.LoadGlobalParam();
        }
        if (
            this.GetGlobalParam() == null ||
            this.GetGlobalParam().LogoPicUrl == null
        )
            return "";

        return this.GetGlobalParam().LogoPicUrl;
    },
    GetSysName: function () {
        return StarSoft.SysInfo.SysName;
    },
    /**
     * 获取菜单对应的路由编码
     */
    GetMenuRouteCode: function (menuItem) {
        return menuItem.RightCode + "_" + menuItem.RightId;
    },
    /**
     * 获取选项卡ID
     */
    GetMenuTabID: function (menuItem) {
        return menuItem.RightCode + "_" + menuItem.RightId;
    },
    Login: fLogin,
    LoginOut:
        /**
         * 退出登录
         * @param {bool} isAuto  自动超时退出非人为操作
         */
        function (callback, isAuto) {
            fClearLoginCatch();
            if (!StarSoft.LoginKey) {
                fFinishLoginOut();
                return;
            }
            try {
                var ajaxOpt = {
                    url:
                        StarSoft.SysInfo.HttpMainUrl +
                        StarSoft.SysInfo.LoginOutUrl,
                    type: "get", //GET
                    beforeSend: function (xhr) {
                        if (StarSoft.LoginKey) {
                            xhr.setRequestHeader("loginkey", StarSoft.LoginKey);
                        }
                    },
                    //async: false,    //或false,是否异步
                    dataType: "json", //返回的数据格式：
                    complete: function () {
                        fFinishLoginOut();
                    }
                };
                var iframeDomain = fGetDomain(ajaxOpt.url);
                if (pageDomain != iframeDomain) {
                    $.support.cors = true;
                    ajaxOpt.crossDomain = true;
                }
                $.ajax(ajaxOpt);
            } catch (e) {
                fFinishLoginOut();
            }

            function fFinishLoginOut() {
                StarSoft.isInitSys = false;
                StarSoft.LoginKey = "";
                StarSoft.V8LoginKey = "";
                StarSoft.isLogin = false;
                delCookie()
                //xzz
                localStorage.removeItem("localAlarm");
                sessionStorageObj.remove("NoticeTotals");
                // localStorage.removeItem("changeRing");
                if (isAuto) {
                    var hashUrl = location.hash;
                    console.info("自动退出 当前锚点", hashUrl);
                    if (
                        hashUrl &&
                        StarSoft.noAlertPage.indexOf(hashUrl) == -1
                    ) {
                        localStorage.setItem(StarSoft.Keys.lastPage, hashUrl);
                    }
                } else {
                    localStorage.setItem(StarSoft.Keys.lastPage, "");
                }
                callback && callback();
            }
            function delCookie() {
                var cookies = document.cookie.split(";");
                for (var i = 0; i < cookies.length; i++) {
                    var cookie = cookies[i];
                    var eqPos = cookie.indexOf("=");
                    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                    document.cookie =
                        name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
                }
                if (cookies.length > 0) {
                    for (var i = 0; i < cookies.length; i++) {
                        var cookie = cookies[i];
                        var eqPos = cookie.indexOf("=");
                        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                        // var domain = location.host.substr(location.host.indexOf("."));
                        var hostArr = location.host.split('.')
                        var domain = hostArr.length === 2 ? hostArr.join('.') : hostArr.slice(1).join('.')
                        document.cookie =
                            name +
                            "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" +
                            domain;
                    }
                }
            }
        },
    fLoginSucCallback: fLoginSucCallback,
    InitSys:
        /**
         * 系统初始化 add by chenk 2018.01.03
         * @param {function} callback 回调方法 带一个参数,如果为null则表示已经初始化过
         */
        function (callback, isLogin) {
            var that = this;
            //debugger;
            if (!StarSoft.Menudata) {
                StarSoft.Menudata = []; //所有菜单数组
            }
            const isInitSys = StarSoft.isInitSys; // localStorage.getItem(StarSoft.Enum.isInitSys);
            if (isInitSys) {
                fInitRoute(null, callback);
                return;
            }
            if (!StarSoft.SysInfo) {
                InitDefaultSysInfo(async function () {
                    if (window.location.hash.includes("Authorization")) {
                        const URLdata = getSearchParams(window.location.hash);
                        var loginData = await checkAuthorization({
                            authorization: URLdata.Authorization
                        })
                        // if (!loginData) return
                        if (loginData) {
                            StarSoft.LoginKey = loginData.loginKey
                        }
                    }
                    GetInitInfo(callback);
                });
                return;
            }

            GetInitInfo(callback);

            //#region  已作废 modify by chenk 2019.09.11

            // /**
            //  * 获取二级菜单
            //  */
            // function fGetSecondMenuData() {
            //         var ajaxOpt = {
            //                 url: StarSoft.SysInfo.HttpMainUrl + StarSoft.SysInfo.HttpMenuJson,
            //                 type: 'get', //GET
            //                 data: "level=1",
            //                 beforeSend: function (xhr) {
            //                         if (StarSoft.LoginKey) {
            //                                 xhr.setRequestHeader("loginkey", StarSoft.LoginKey);
            //                         }
            //                 },
            //                 //async: false,    //或false,是否异步
            //                 dataType: 'json',    //返回的数据格式：
            //                 success: function (data) {
            //                         if (!data.Suc) {
            //                                 console.info("获取二级菜单", data);
            //                                 alert(data.Info);
            //                                 fInitRoute(null);
            //                                 return;
            //                         }
            //                         var InitInfo = StarSoft.InitInfo;
            //                         InitInfo.SecondMenuData = data.Data;

            //                         if (!InitInfo.SecondMenuData || InitInfo.SecondMenuData.length == 0) {
            //                                 fInitRoute(InitInfo);
            //                                 return;
            //                         }
            //                         StarSoft.Menudata = StarSoft.Menudata.concat(data.Data);
            //                         if (!InitInfo.ThirdMenuData) {
            //                                 fGetThirdMenuData();
            //                                 return;
            //                         }
            //                         else {
            //                                 StarSoft.Menudata = StarSoft.Menudata.concat(InitInfo.ThirdMenuData);
            //                         }
            //                         fInitRoute(InitInfo);
            //                         return;
            //                 },
            //                 error: function () {
            //                         fInitRoute(null);
            //                 }
            //         };
            //         if (StarSoft.LoginKey) {
            //                 ajaxOpt.Data = { "loginKey": StarSoft.LoginKey };
            //         }
            //         $.ajax(ajaxOpt);

            // }
            // /**
            //                         * 获取三级菜单
            //                         */
            // function fGetThirdMenuData() {
            //         var ajaxOpt = {
            //                 url: StarSoft.SysInfo.HttpMainUrl + StarSoft.SysInfo.HttpMenuJson,
            //                 type: 'get', //GET
            //                 data: "level=2",
            //                 beforeSend: function (xhr) {
            //                         if (StarSoft.LoginKey) {
            //                                 xhr.setRequestHeader("loginkey", StarSoft.LoginKey);
            //                         }
            //                 },
            //                 //async: false,    //或false,是否异步
            //                 dataType: 'json',    //返回的数据格式：
            //                 success: function (data) {
            //                         if (!data.Suc) {
            //                                 console.info("获取三级菜单", data);
            //                                 alert(data.Info);
            //                                 fInitRoute(null);
            //                                 return;
            //                         }
            //                         var InitInfo = StarSoft.InitInfo;
            //                         InitInfo.ThirdMenuData = data.Data;
            //                         StarSoft.Menudata = StarSoft.Menudata.concat(InitInfo.ThirdMenuData);
            //                         fInitRoute(InitInfo);
            //                         return;
            //                 },
            //                 error: function () {
            //                         fInitRoute(null);
            //                 }
            //         };
            //         if (StarSoft.LoginKey) {
            //                 ajaxOpt.Data = { "loginKey": StarSoft.LoginKey };
            //         }
            //         $.ajax(ajaxOpt);
            // }
            //#endregion  已作废 modify by chenk 2019.09.11
        },
    InitDefaultSysInfo:
        /**
         * 初始化默认全局参数 add by chenk
         */
        function (callback) {
            var pathname = location.pathname
            pathname = pathname.replace(/\//g, "");
            $.ajax({
                url: `static/GlobalParam${pathname ? "-" + pathname : ''}.json?v=` + Date.now(),
                type: "get", //GET
                //async: false,    //false 为同步，true 为异步
                dataType: "json", //返回的数据格式：
                success: function (data) {
                    console.log("完成加载系统初始化参数");
                    StarSoft.SysInfo = data;
                    callback && callback();
                },
                error: function (e) {
                    console.error("加载系统初始化参数出错", e);
                    StarSoft.SysInfo = {
                        HttpMenuJson: "api/User/PowerData/GetMenuInfo",
                        HomePage: "/emptyPage",
                        IsHomePageScreen: 0,
                        ExitLogin: "",
                        SysTimeOut: 4,
                        WebUrl: "",
                        WebTitle: "智慧商砼企业综合管理系统",
                        SysName: "",
                        LogoPicUrl: "static/logo.png",
                        LoginView: "../components/page/Login.vue",
                        InitUrl: "api/User/PowerData/GetInitInfo",
                        CheckLoginUrl: "api/User/Login/CheckLogin",
                        LoginOutUrl: "api/User/Login/LoginOut",
                        SSVersion: {
                            V1_1: "1.1"
                        },
                        SysType: 1
                    };
                    callback && callback();
                }
            });
        },

    GetIndexRoute:
        /**
         * 获取首页路由，路由未初始化时返回空白页面路由 add by chenk 2019.01.09
         * @param {bool} isIndex 获取默认首页
         * @returns 路由
         */
        function (isIndex) {
            var that = this;
            if (!StarSoft || !StarSoft.isInitSys) {
                return "/emptyPage";
            }
            //去掉返回上次页面方法 modify by chenk 2019.07.05
            // if (!isIndex) {
            //         var lastPage = localStorage.getItem(StarSoft.Keys.lastPage);
            //         if (lastPage && StarSoft.noAlertPage.indexOf(lastPage) == -1 && lastPage.indexOf("KanbanSet_4005?onepage=true") == -1) {
            //                 console.info("登录成功后返回上次页面", lastPage);
            //                 localStorage.setItem(StarSoft.Keys.lastPage, "");
            //                 return lastPage.substring(1);
            //         }
            // }
            var right = _GetIndexRouteRight();
            if (!right) {
                return "/emptyPage";
            }
            return "/" + that.GetMenuRouteCode(right);
        },
    GetRightByRightCode:
        /**
         * 根据菜单编号获取菜单数据对象 add by chenk 2019.01.09
         * @returns 路由
         */
        function (rightCode) {
            var data = StarSoft.Menudata;
            for (var i = 0; i < data.length; i++) {
                var node = data[i];
                if (node.RightCode == rightCode) {
                    return node;
                }
            }
            return null;
        },
    InitLeftMenuData:
        /**
         * 生成左侧菜单数据
         * @returns {array} 左侧菜单数组
         */
        function (isURL) {
            //todo 改写菜单
            console.log("isURL", isURL);
            var allMenuData = StarSoft.Menudata;
            if (StarSoft.ShowLeftRightID && isURL) {
                let MenuData = [];
                allMenuData.forEach(item => {
                    if (
                        StarSoft.ShowLeftRightID == item.RightId &&
                        item.ParentID == 0
                    ) {
                        let itemObj = RightToMenu(item);
                        MenuData.push(itemObj);
                        fInitChildMenu(itemObj, item);
                        let findItem = findFirstPage([itemObj])
                        console.log('findItem', findItem);
                        if (findItem) {
                            itemObj.index = findItem.index;
                            itemObj.UrlPrefix = findItem.rlPrefix;
                            itemObj.HasPage = findItem.HasPage;
                            itemObj.isIframe = findItem.isIframe;
                            itemObj.tabId = findItem.tabId;
                        }
                    } else if (StarSoft.ShowLeftRightID == item.RightId) {
                        let itemObj = RightToMenu(item);
                        MenuData.push(itemObj);
                        fInitChildMenu(itemObj, item);
                        if (
                            !itemObj.HasPage &&
                            itemObj.subs &&
                            StarSoft.SysInfo.SysType == 1
                        ) {
                            let child = itemObj.subs.find(p => p.HasPage);
                            if (child) {
                                itemObj.index = child.index;
                                itemObj.UrlPrefix = child.UrlPrefix;
                                itemObj.HasPage = child.HasPage;
                                itemObj.isIframe = child.isIframe;
                                itemObj.tabId = child.tabId;
                            } else {
                                let flag = true;
                                itemObj.subs.forEach(sub => {
                                    sub.subs = sub.subs && sub.subs.length ? sub.subs : []
                                    let finalSub = sub.subs.find(
                                        p => p.HasPage
                                    );
                                    if (finalSub && flag) {
                                        flag = false;
                                        itemObj.index = finalSub.index;
                                        itemObj.UrlPrefix = finalSub.UrlPrefix;
                                        itemObj.HasPage = finalSub.HasPage;
                                        itemObj.isIframe = finalSub.isIframe;
                                        itemObj.tabId = finalSub.tabId;
                                    }
                                });
                            }
                        } else {
                            // 隐藏侧边
                            StarSoft.showLeftNav = false;
                        }
                    }
                });
                if (MenuData.length != 0) {
                    // 更改跳转路由
                    StarSoft.ShowLeftRightID = MenuData[0].index;
                    // 隐藏头部
                    StarSoft.topInfoNav = false;
                } else {
                    StarSoft.topInfoNav = false;
                    StarSoft.showLeftNav = false;
                }
                return MenuData;
            }
            var MenuStorage = []; //存放菜单信息
            if (!allMenuData || allMenuData.length == 0) {
                return MenuStorage;
            }

            for (var i = 0; i < allMenuData.length; i++) {
                var fristItem = allMenuData[i];
                if (fristItem.IsHide || fristItem.ParentID != 0) {
                    continue;
                }
                var itemObj = RightToMenu(fristItem);
                MenuStorage.push(itemObj);
                fInitChildMenu(itemObj, fristItem);
                if (
                    !itemObj.HasPage &&
                    itemObj.subs &&
                    StarSoft.SysInfo.SysType == 1
                ) {
                    let flag = true;
                    var child = itemObj.subs.find(p => p.HasPage);
                    if (child) {
                        itemObj.index = child.index;
                        itemObj.UrlPrefix = child.UrlPrefix;
                        itemObj.HasPage = child.HasPage;
                        itemObj.isIframe = child.isIframe;
                        itemObj.tabId = child.tabId;
                    } else {
                        itemObj.subs.forEach(sub => {
                            // console.log(11111, sub)
                            sub.subs = sub.subs && sub.subs.length ? sub.subs : []
                            let finalSub = sub.subs.find(p => p.HasPage);

                            if (finalSub && flag) {
                                flag = false;
                                itemObj.index = finalSub.index;
                                itemObj.UrlPrefix = finalSub.UrlPrefix;
                                itemObj.HasPage = finalSub.HasPage;
                                itemObj.isIframe = finalSub.isIframe;
                                itemObj.tabId = finalSub.tabId;
                            }
                            if (flag) {
                                sub.subs.forEach(fina => {
                                    if (fina.subs) {
                                        let bottom = fina.subs.find(p => p.HasPage);
                                        if (bottom && flag) {
                                            flag = false;
                                            itemObj.index = bottom.index;
                                            itemObj.UrlPrefix = bottom.UrlPrefix;
                                            itemObj.HasPage = bottom.HasPage;
                                            itemObj.isIframe = bottom.isIframe;
                                            itemObj.tabId = bottom.tabId;
                                        }
                                    }
                                });
                            }
                        });
                        // itemObj.index = itemObj.subs[0].subs[0].index;
                        // itemObj.UrlPrefix = itemObj.subs[0].subs[0].UrlPrefix;
                        // itemObj.HasPage = itemObj.subs[0].subs[0].HasPage;
                        // itemObj.isIframe = itemObj.subs[0].subs[0].isIframe;
                        // itemObj.tabId = itemObj.subs[0].subs[0].tabId;
                    }
                }
                //#endregion 自己没页面查找子菜单页面
            }

            /**
             * 构造子菜单
             * @param {json} parentMenu  父菜单
             * @param {json} parentRight 父菜单对应的权限
             */
            function fInitChildMenu(parentMenu, parentRight) {
                if (parentRight.MenuType) {
                    return;
                }
                parentMenu.subs = [];
                for (var i = 0; i < allMenuData.length; i++) {
                    var node = allMenuData[i];
                    if (node.ParentID != parentMenu.ID || node.IsHide) {
                        continue;
                    }
                    var childMenu = RightToMenu(node);
                    parentMenu.subs.push(childMenu);
                    childMenu.parentTitle = parentMenu.title;
                    fInitChildMenu(childMenu, node);
                }
                if (parentMenu.subs.length == 0) {
                    delete parentMenu.subs;
                }
            }

            /**
             * 权限数据转化为菜单对象
             * @param {json} right  权限数据
             */
            function RightToMenu(right) {
                var HasPage = !!right.RightUrl;
                var itemObj = {
                    icon: right.ImgMark,
                    index: "/" + ApplicationMgr.GetMenuRouteCode(right),
                    title: right.RightName,
                    ID: right.RightId,
                    ParentID: right.ParentID,
                    sortID: right.SortOrder,
                    UrlPrefix: right.UrlPrefix,
                    HasPage: HasPage,
                    isIframe: right.IsIframe,
                    Query: right.Query,
                    tabId: ApplicationMgr.GetMenuTabID(right)
                };
                return itemObj;
            }

            /*比较数子大小，用于菜单的排序*/
            function compare(property) {
                return function (a, b) {
                    var value1 = a[property];
                    var value2 = b[property];
                    return value1 - value2;
                };
            }

            /**
             * 递归函数查询没有直接子页面的第一个页面
             * */
            function findFirstPage(list) {
                let nextList = []
                let findOne = null
                list.forEach(item => {
                    if (!item.HasPage && item.subs.length && StarSoft.SysInfo.SysType == 1) {
                        nextList.push(...item.subs)
                    }
                    if (item.HasPage && !findOne) {
                        findOne = item
                    }
                })
                if (findOne) {
                    return findOne
                }
                if (nextList.length) {
                    findOne = findFirstPage(nextList)
                }
                return findOne
            }
            return MenuStorage;
        },

    InitRightMenu: function (data) {
        var arr = [];
        data.forEach(item => {
            var HasPage = !!item.RightUrl;
            var obj = {
                HasPage: HasPage,
                ID: item.RightId,
                ParentID: item.ParentID,
                UrlPrefix: item.UrlPrefix,
                icon: item.ImgMark,
                index: "/" + item.RightCode + "_" + item.RightId,

                isIframe: item.IsIframe,
                sortID: item.SortOrder,
                title: item.RightName
            };
            arr.push(obj);
        });
        return arr;
    },
    fSetCrossDomainUrl: fSetCrossDomainUrl,
    fGetDomain: fGetDomain,
    fInitOPOAPage: fInitOPOAPage,
    fGetFirstChildMenu:
        /**
         * 查找第一个子菜单 add by chenk 2019.05.31
         * @param {int} rightid 菜单id
         */
        function (rightid) {
            for (var i = 0; i < StarSoft.MenuData; i++) {
                var node = StarSoft.MenuData[i];
                if (node.ParentID == rightid) {
                    return node;
                }
            }
            return null;
        }
};

export default ApplicationMgr;
